/* ============================================================
   PawsKeeen Theme — theme.js
   ============================================================ */

(function () {
  'use strict';

  /* ---- Countdown Timer ---- */
  function initCountdown() {
    var hoursEl = document.getElementById('cd-hours');
    var minsEl  = document.getElementById('cd-mins');
    var secsEl  = document.getElementById('cd-secs');
    if (!hoursEl || !minsEl || !secsEl) return;

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      var now = new Date();
      var end = new Date(now);
      end.setHours(24, 0, 0, 0);
      var diff = Math.max(0, Math.floor((end - now) / 1000));
      var h = Math.floor(diff / 3600);
      diff -= h * 3600;
      var m = Math.floor(diff / 60);
      var s = diff - m * 60;
      hoursEl.textContent = pad(h);
      minsEl.textContent  = pad(m);
      secsEl.textContent  = pad(s);
    }

    tick();
    setInterval(tick, 1000);
  }

  /* ---- Tabs ---- */
  function initTabs() {
    document.querySelectorAll('[data-tabs]').forEach(function (tabs) {
      var btns   = tabs.querySelectorAll('.tabs__btn');
      var panels = tabs.querySelectorAll('.tabs__panel');

      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var idx = btn.dataset.tab;
          btns.forEach(function (b) { b.classList.remove('is-active'); });
          panels.forEach(function (p) { p.classList.remove('is-active'); });
          btn.classList.add('is-active');
          var panel = tabs.querySelector('[data-panel="' + idx + '"]');
          if (panel) panel.classList.add('is-active');
        });
      });
    });
  }

  /* ---- Timeline scroll arrows ---- */
  function initTimeline() {
    var wrap = document.getElementById('timelineScroll');
    var prev = document.getElementById('timelinePrev');
    var next = document.getElementById('timelineNext');
    if (!wrap) return;
    function cardWidth() {
      var card = wrap.querySelector('.timeline__card');
      return card ? card.offsetWidth + 20 : 280;
    }
    if (prev) prev.addEventListener('click', function () { wrap.scrollBy({ left: -cardWidth(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { wrap.scrollBy({ left:  cardWidth(), behavior: 'smooth' }); });
  }

  /* ---- Reviews Slider ---- */
  function initReviewsSlider() {
    var slider = document.getElementById('reviewsSlider');
    var prev   = document.getElementById('reviewsPrev');
    var next   = document.getElementById('reviewsNext');
    if (!slider) return;

    var current = 0;
    var cards   = slider.querySelectorAll('.reviews__card');
    var visible = window.innerWidth <= 768 ? 1 : 3;
    var max     = Math.max(0, cards.length - visible);

    function goTo(idx) {
      current = Math.max(0, Math.min(max, idx));
      var cardWidth = cards[0] ? cards[0].offsetWidth + 24 : 0;
      slider.style.transform = 'translateX(-' + (current * cardWidth) + 'px)';
      slider.style.transition = 'transform .45s cubic-bezier(.4,0,.2,1)';
    }

    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });

    window.addEventListener('resize', function () {
      visible = window.innerWidth <= 768 ? 1 : 3;
      max = Math.max(0, cards.length - visible);
      goTo(Math.min(current, max));
    });
  }

  /* ---- Marquee: ensure CSS animation running ---- */
  function initMarquees() {
    document.querySelectorAll('.marquee-track').forEach(function (track) {
      var speed = track.style.animationDuration || '28s';
      track.style.animationDuration = speed;
      track.style.animationPlayState = 'running';
    });
  }

  /* ---- Product Gallery ---- */
  function initProductGallery() {
    var thumbs = document.querySelectorAll('.product-hero__thumb');
    var mains  = document.querySelectorAll('.product-hero__main-img');
    if (!thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = thumb.dataset.thumb;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        mains.forEach(function (m) { m.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        var main = document.querySelector('.product-hero__main-img[data-main="' + idx + '"]');
        if (main) main.classList.add('is-active');
      });
    });
  }

  /* ---- Horizontal carousel helper ---- */
  function initCarousel(trackId, prevId, nextId, cardSelector) {
    var track = document.getElementById(trackId);
    var prev  = document.getElementById(prevId);
    var next  = document.getElementById(nextId);
    if (!track) return;
    function step() {
      var card = track.querySelector(cardSelector);
      return card ? card.offsetWidth + 20 : 320;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollLeft -= step(); });
    if (next) next.addEventListener('click', function () { track.scrollLeft += step(); });
  }

  /* ---- Before / After Slider ---- */
  function initBeforeAfter() {
    var frame   = document.getElementById('beforeAfterFrame');
    var clip    = document.getElementById('beforeAfterClip');
    var divider = document.getElementById('beforeAfterDivider');
    var handle  = document.getElementById('beforeAfterHandle');
    var beforeImg = document.getElementById('beforeAfterBeforeImg');
    if (!frame || !clip) return;

    var dragging = false;

    function setWidth() {
      if (beforeImg) beforeImg.style.width = frame.getBoundingClientRect().width + 'px';
    }
    setWidth();
    window.addEventListener('resize', setWidth);

    function setPct(pct) {
      pct = Math.min(100, Math.max(0, pct));
      clip.style.width = pct + '%';
      divider.style.left = pct + '%';
      handle.style.left = pct + '%';
    }

    function move(e) {
      if (!dragging) return;
      var rect = frame.getBoundingClientRect();
      var x = (e.clientX || (e.touches && e.touches[0].clientX) || 0) - rect.left;
      setPct((x / rect.width) * 100);
    }

    frame.addEventListener('mousedown', function () { dragging = true; });
    frame.addEventListener('touchstart', function () { dragging = true; }, { passive: true });
    document.addEventListener('mouseup', function () { dragging = false; });
    document.addEventListener('touchend', function () { dragging = false; });
    document.addEventListener('mousemove', move);
    document.addEventListener('touchmove', move, { passive: true });
  }

  /* ---- Myths scroll reveal ---- */
  function initMythsReveal() {
    var items = document.querySelectorAll('.myths__item');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (i) { i.classList.add('is-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    items.forEach(function (i) { obs.observe(i); });
  }

  /* ---- Cart Page ---- */
  function initCartPage() {
    var items = document.getElementById('cartItems');
    if (!items) return;

    function updateCart(key, qty) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
      .then(function (r) { return r.json(); })
      .then(function () { location.reload(); })
      .catch(function () { location.reload(); });
    }

    items.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-action]');
      if (!btn) return;
      var key    = btn.dataset.key;
      var action = btn.dataset.action;
      var safeId = key.replace(/:/g, '-');
      var numEl  = document.getElementById('qty-' + safeId);
      var current = numEl ? parseInt(numEl.textContent, 10) : 1;

      if (action === 'decrease') {
        updateCart(key, Math.max(0, current - 1));
      } else if (action === 'increase') {
        updateCart(key, current + 1);
      }
    });

    items.addEventListener('click', function (e) {
      var btn = e.target.closest('.cart-item__remove');
      if (!btn) return;
      updateCart(btn.dataset.key, 0);
    });
  }

  /* ---- Mobile Nav Overlay ---- */
  function initNav() {
    var burger  = document.getElementById('navBurger');
    var overlay = document.getElementById('navOverlay');
    var closeBtn = document.getElementById('navClose');
    if (!burger || !overlay) return;
    function openNav() {
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeNav() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    burger.addEventListener('click', openNav);
    if (closeBtn) closeBtn.addEventListener('click', closeNav);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeNav();
    });
  }

  /* ---- FAQ Accordion ---- */
  function initFaq() {
    document.querySelectorAll('[data-faq] .faq__item').forEach(function (item) {
      var btn = item.querySelector('.faq__q');
      var ans = item.querySelector('.faq__a');
      if (!btn || !ans) return;
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        document.querySelectorAll('[data-faq] .faq__q').forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
          var a = b.parentElement.querySelector('.faq__a');
          if (a) a.style.maxHeight = null;
        });
        if (!open) {
          btn.setAttribute('aria-expanded', 'true');
          ans.style.maxHeight = ans.scrollHeight + 'px';
        }
      });
    });
  }

  /* ---- Init on DOM ready ---- */
  function init() {
    initCartPage();
    initNav();
    initCountdown();
    initTabs();
    initTimeline();
    initReviewsSlider();
    initMarquees();
    initProductGallery();
    initCarousel('videoReviewsTrack', 'videoReviewsPrev', 'videoReviewsNext', '.video-reviews__card');
    initCarousel('textReviewsTrack', 'textReviewsPrev', 'textReviewsNext', '.text-reviews__card');
    initBeforeAfter();
    initMythsReveal();
    initFaq();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
